import * as React from 'react';

import { useLoaderData, useNavigate} from 'react-router-dom';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import BigCardGrid from '../components/BigCardGrid';
import Filter from '../components/Filter';

import AddIcon from '@mui/icons-material/Add';

import EwpFab from "../components/EwpFab";
import Header from "../components/Header";

import AnimalCard from "../components/cards/AnimalCard";


import { listAnimals } from "../models/animals";
import { listAssessments } from "../models/assessments";
import { listChanges } from "../models/changes";

import { getAnimalLastAssessments } from '../utils/assessments';
import { name as speciesName } from '../utils/species';

// if you need to load data, you can use this template, note that the return value needs to be an object with named records in it.

export async function loader() {
	const animals = await listAnimals();
	const assessments = await listAssessments();
	const changes = await listChanges();
	return { animals, assessments, changes };
}


export default function AnimalListPage({title = "Animals",...props}) {
    const navigate = useNavigate();
    const {animals,assessments,changes} = useLoaderData(); 

    const animalLastAssessments = getAnimalLastAssessments(animals,assessments);
    const [filteredAnimals, setFilteredAnimals] = React.useState(animals);

    const speciesOptions = React.useMemo(() => {
        const values = Array.from(
            new Set((animals || []).map((cur) => String(cur.species || '').trim()).filter(Boolean))
        );
        values.sort((a, b) => a.localeCompare(b));
        return values.map((value) => ({value, label: speciesName(value)}));
    }, [animals]);

    const sexOptions = React.useMemo(() => {
        const values = Array.from(
            new Set((animals || []).map((cur) => String(cur.sex || '').trim()).filter(Boolean))
        );
        values.sort((a, b) => a.localeCompare(b));
        return values.map((value) => ({value, label: value}));
    }, [animals]);

    const locationOptions = React.useMemo(() => {
        const values = Array.from(
            new Set((animals || []).map((cur) => String(cur.location || '').trim()).filter(Boolean))
        );
        values.sort((a, b) => a.localeCompare(b));
        return values.map((value) => ({ value, label: value }));
    }, [animals]);

    const filterOptions = React.useMemo(() => ([
        {
            key: 'name',
            label: 'Animal Name',
            type: 'text'
        },
        {
            key: 'studbook_number',
            label: 'ID Number',
            type: 'text'
        },
        {
            key: 'species',
            label: 'Species',
            type: 'single-select',
            list: speciesOptions
        },
        {
            key: 'sex',
            label: 'Sex',
            type: 'single-select',
            list: sexOptions
        },
        {
            key: 'location',
            label: 'Location',
            type: 'single-select',
            list: locationOptions
        },
    ]), [sexOptions, speciesOptions, locationOptions]);

    const sortOptions = React.useMemo(() => ([
        {
            key: 'name',
            label: 'Animal Name',
            default: 'asc'
        },
        {
            key: 'studbook_number',
            label: 'ID Number'
        },
        {
            key: 'species',
            label: 'Species'
        },
        {
            key: 'sex',
            label: 'Sex'
        },
    ]), []);

    const navigateToAnimal = (id) => {
        console.log(id);
        navigate("/animals/" + id);
    }

    // note you can play with the container maxwidth to spread out the window content appears in
    return (
        <Container component="main">
            <Header label={title} />
            <Filter
                records={animals}
                setFilteredRecords={setFilteredAnimals}
                filterOptions={filterOptions}
                sortOptions={sortOptions}
                badgeColor="success"
            />

            <Grid container spacing={2}>
            {filteredAnimals.map((animal)=>{

                const lastAssessment = animalLastAssessments[animal.id].assessment || null;

                return (
                    <BigCardGrid key={animal.id}> 
                        <AnimalCard animal={animal} lastAssessment={lastAssessment} changes={changes} onActionAreaClick={()=>{navigateToAnimal(animal.id)}} />
                    </BigCardGrid>
                );

            })}
            </Grid>
            <EwpFab onClick={()=>navigate("/animals/form")}>
                <AddIcon />
            </EwpFab>
        </Container>
    );
}
